"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableResponsiveMixin = void 0;
/** @class TableResponsiveMixin */
/** @method */
var TableResponsiveMixin = function TableResponsiveMixin() {
  return "\n    /* On smaller screens, enable horizontal scroll */\n    overflow-x: auto;\n";
};
exports.TableResponsiveMixin = TableResponsiveMixin;